import {z} from 'zod'

// What POST /stripeConsumer/promoPrice returns. A schema rather than a bare interface so the client
// parses the response instead of asserting a shape onto fetch's `any`.
export const promoPriceSchema = z.object({
  priceId: z.string(),
  currency: z.string(),
  // Amounts are Stripe's integer minor units (e.g. cents), matching Stripe.Price.unit_amount.
  originalAmount: z.number(),
  // Equal to originalAmount when the promo code doesn't apply (unknown/inactive code, or a coupon
  // this endpoint can't model — see getPromoPrice).
  finalAmount: z.number(),
  // Set only for percentage coupons (e.g. 25 for 25% off); null otherwise, including amount-off
  // coupons whose discount is reflected in finalAmount but has no single percentage.
  discountPercentage: z.number().nullable()
})
export type PromoPrice = z.infer<typeof promoPriceSchema>
